import { processDevicesData } from "./device";
import { processCameraDeviceLocations } from "./crowds";

const BATTERY_THRESHOLD = 25;

function sortById(a, b) {
    return a.group_id - b.group_id;
}

export function processSubgroupData(fetch_time, group, devices, show_inactive) {

    if (devices != null) {
        group.uuids = [];

        for (var subgroup of group.subgroups) {
            subgroup.devices_monitored = 0;
            var subgroup_devices = devices.filter(function (row) {
                return subgroup.uuids.indexOf(row.uuid) > -1;
            });

            subgroup.devices = processDevicesData(fetch_time, subgroup_devices, show_inactive);
            subgroup = getUpdatedStats(subgroup);

            for (var uuid of subgroup.uuids) {
                group.uuids = group.uuids.concat(uuid);
            }
        }
    }

    group.subgroups = group.subgroups.sort(sortById);

    return group;
}

export function processParentGroupData(parent_group) {
    var ret = {
        group_id: parent_group.group_id,
        name: parent_group.name,
        geojson: parent_group.geojson,
        organisation_id: parent_group.organisation_id
    };

    return ret;
}

export function getUpdatedStats(group) {
    group.all_updated = true;

    for (var device of group.devices) {
        if (device.active) {
            if (device.connected_state == 'offline') {
                group.all_updated = false;
            }
            if (device.battery <= BATTERY_THRESHOLD) {
                group.devices_monitored++;
            }
        }
    }

    return group;
}

export function processGroupData(fetch_time, group, devices = [], show_inactive = false, camera_locations = false) {

    if (group != null) {
        group.devices_monitored = 0;
        if (group.subgroups.length > 0) {
            group = processSubgroupData(fetch_time, group, devices, show_inactive);
        }

        if (group.parent_group.length > 0) {
            group.parent_group = processParentGroupData(group.parent_group[0]);
        }

        if (devices != null) {
            var devices_list = devices.filter(function (row) {
                return group.uuids.indexOf(row.uuid) > -1;
            });

            group.devices = processDevicesData(fetch_time, devices_list, show_inactive);
            if (camera_locations) {
                group.devices = processCameraDeviceLocations(group.devices, camera_locations);
            }
            group = getUpdatedStats(group);
        }
    }

    return group;
}

export function processGroupsData(fetch_time, groups, devices = [], show_inactive = false, camera_locations = false) {

    var processed = groups.map(function (group) {
        return processGroupData(fetch_time, group, devices, show_inactive, camera_locations);
    });

    return processed;
}

export function createGroupDataTableRows(groups_data, showAdvancedDeviceLevel) {

    return {
        columns: [
            {
                Header: 'Group Name',
                accessor: 'name'
            },
            {
                Header: 'Devices',
                accessor: 'accessor_id'
            },
            {
                Header: 'Type',
                accessor: 'type'
            }
        ],
        rows: []
    }
}

export function processStopmonitorGroupData(fetch_time, group, sites = [], devices = [], showAdvancedDeviceLevel = false) {
    var ret = { ...group };

    ret.sites = sites.filter(site => group.sites.indexOf(site.site_id) > -1);
    ret.devices = processDevicesData(fetch_time, devices.filter(dev => group.uuids.includes(dev.uuid)), showAdvancedDeviceLevel);

    ret.entities = [];
    switch (group.type) {
        case 'campaigns':
            ret.entities = ret.sites;
            break;
        default:
            ret.entities = ret.devices;
            break;
    }

    // if (camera_locations) {
    //     group.devices = processCameraDeviceLocations(group.devices, camera_locations);
    // }

    return ret;
}